import '@dotlottie/player-component';

function AboutAnim() {
  return (
    <div className="App">
      <dotlottie-player
        src="https://lottie.host/8e10388c-47d0-47e2-ad42-975eb2d4ecc8/jGnxrFZNAN.lottie"
        autoplay
        loop
        
        // style=
      />
      
    </div>
  );
}

export default AboutAnim;